import TemplateRecordEditor from './TemplateRecordEditor.js';
export { emptyProvisionTemplate } from './TemplateRecordEditor.js';
export default function ProvisionTemplateEditor(props) { return <TemplateRecordEditor {...props} kind="Provision" />; }
